import Vue from 'vue';
import Router from 'vue-router';
import Landing from './components/LandingPage.vue';
import Login from './components/Login.vue';

import Roster from './components/testroster/Roster.vue';
import RosterSummary from './components/testroster/RosterSummary.vue';

import EmployeesMain from './components/employeecontext/EmployeesMain.vue';
import ShiftMain from './components/shiftcontext/ShiftMain.vue';
import StoreMain from './components/storedatacontext/StoreMain.vue';
import WorkBalanceMain from './components/workbalancecontext/WorkBalanceMain.vue';
import ReportMain from './components/reportcontext/ReportMain.vue';

import PlanningIndicatorMain from './components/planningindicatorcontext/PlanningIndicatorMain.vue'
import PreferenceMain from './components/preferencecontext/PreferenceMain.vue'
import CalendarView from './components/preferencecontext/CalendarView.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: 'login',
      name: 'login',
      component: Login
    },
    {
      path: '/employees/:tab',
      name: 'employees',
      component: EmployeesMain,
      props: true
    },
    {
      path: '/musterdienstplansummary',
      name: 'rostersummary',
      component: RosterSummary,
      props: true
    },
    {
      path: '/planning/:tab',
      name: 'planning',
      component: ShiftMain,
      props: true
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: CalendarView,
      props: true
    },
    {
      path: '/storemain/:tab',
      name: 'storemain',
      component: StoreMain,
      props: true
    },
    {
      path: '/planningindicator/:tab',
      name: 'planningindicatormain',
      component: PlanningIndicatorMain,
      props: true
    },
    {
      path: '/preferences/:tab',
      name: 'preferences',
      component: PreferenceMain,
      props: true
    },
    {
      path: '/workbalances/:tab',
      name: 'workbalances',
      component: WorkBalanceMain,
      props: true
    },
    {
      path: '/reports/:tab',
      name: 'reports',
      component: ReportMain,
      props: true
    },
    {
      path: '/landing',
      name: 'landing',
      component: Landing,
      props: true
    },
  ]
})